import React, { PureComponent } from 'react'
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  Home,
  Sobre,
  Produtos,
  Contato,
  Login,
  Signup,
  FinalizarCadastro,
  MinhaConta,
  MeusInvestimentos,
  Indicacoes,
  Contratos,
  ConfirmConta,
  ResetPassword,
  Faq,
  PoliticaDePrivacidade,
  Wallet, 
  BrlDepResWallet,
  BtcDepResWallet,
  RibDepResWallet,
  ConversaoWallet,
  ExtratoWallet,
  FlwtPainel,
  FlwtWallet,
  DetalhesTransacao,
  TransacaoNotFound,
  ListaDeEspera,
  ProdutosWallet,
  ProdutosFLWT,
  Page404
} from '../Pages'
import 'antd/dist/antd.css';
import '../App.css'

export const ENV = process.env.REACT_APP_ENV

class Production extends PureComponent {
  render() {
      return (
        <Router>
          <Switch>
            <Route path="/" exact component={Home} />
            {/* <Route path="/sobre" component={Sobre} /> */}
            {/* <Route path="/nossos-fundos" component={Produtos} /> */}
            {/* <Route path="/suporte" component={Contato} /> */}
            <Route path="/suporte" component={Home} />
            <Route path="/login" component={Login} />
            <Route path="/cadastro" component={Signup} />
            <Route path="/finalizar-cadastro" component={FinalizarCadastro} />
            <Route path="/minhaconta" component={MinhaConta} />
            <Route path="/meusinvestimentos" component={MeusInvestimentos} />
            <Route path="/indicacoes" component={Indicacoes} />
            <Route path="/contratos" component={Contratos} />
            <Route path="/confirm" component={ConfirmConta} />
            {/* <Route path="/faq" component={Faq} /> */}
            <Route path="/reset" component={ResetPassword} />
            <Route path="/reset-password" component={ResetPassword} />
            {/* <Route path="/politica-de-privacidade" component={PoliticaDePrivacidade} /> */}
            {/* <Route path="/produtos/wallet" component={ProdutosWallet} />
            <Route path="/produtos/flwt" component={ProdutosFLWT} /> */}
            <Route exact sensitive path="/wallet" component={MeusInvestimentos} />
            <Route path="/wallet/brl" component={BrlDepResWallet} />
            <Route path="/wallet/btc" component={BtcDepResWallet} />
            <Route path="/wallet/rib" component={RibDepResWallet} />
            <Route path="/wallet/converter" component={ConversaoWallet} />
            <Route path="/wallet/extrato" component={ExtratoWallet} />
            <Route path="/wallet/transacao" component={DetalhesTransacao} />
            <Route path="/wallet/404" component={TransacaoNotFound} />
            <Route path="/wallet/lista-de-espera" component={ListaDeEspera} />
            <Route exact sensitive path="/wallet" component={Wallet} />
            <Route path="/wallet/brl" component={BrlDepResWallet} />
            <Route path="/wallet/btc" component={BtcDepResWallet} />
            <Route path="/wallet/rib" component={RibDepResWallet} />
            <Route path="/wallet/converter" component={ConversaoWallet} />
            <Route path="/wallet/extrato" component={ExtratoWallet} />
            <Route path="/wallet/flwt" exact component={FlwtWallet} />
            <Route path="/wallet/flwt/painel" component={FlwtPainel} />
            <Route path="/wallet/transacao" component={DetalhesTransacao} />
            <Route path="/wallet/404" component={TransacaoNotFound} />
            <Route path="/wallet/lista-de-espera" component={ListaDeEspera} />
            <Route component={Page404} />
          </Switch>
        </Router>
      )
  }
}

export default Production